import { render, staticRenderFns } from "./Reversiones.vue?vue&type=template&id=97e43c10&scoped=true"
import script from "./Reversiones.vue?vue&type=script&lang=js"
export * from "./Reversiones.vue?vue&type=script&lang=js"
import style0 from "./Reversiones.vue?vue&type=style&index=0&id=97e43c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e43c10",
  null
  
)

export default component.exports